import * as React from "react";
import { AutoCompleteInput } from "uxp/components";
import { findAvailableFields, IUIPropertyDefinition } from "../../../common/common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { bindContainerId } from "../../../../util";
import { WidgetDesignerPillInput } from "../../../common/pill-input/PillInput";



export function Statistics(title: string, props: string): IUIPropertyDefinition<string> {
    return {
        defaults: props,
        render: (props, uxpContext, data, containerId) => {
            let _props = props.uiProps
            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();
            return <PropertyContainer>
                <PropertyContainerTitle>{title}</PropertyContainerTitle>
                <PropertyGroup>
                    <Property id={bindContainerId('field', containerId)}>
                        <PropertyTitle>Field</PropertyTitle>

                        <WidgetDesignerPillInput
                            value={_props || ''}
                            onChange={s => {
                                props.onChange(s || '')
                            }}
                            contextData={data}
                        />

                        {/* <AutoCompleteInput
                            options={pv}
                            value={_props || ''}
                            onChange={s => {
                                props.onChange(s || '')
                            }}
                            className="widget-designer-input"
                        /> */}
                    </Property>
                </PropertyGroup>
            </PropertyContainer>
        }
    };
}
